const coursetemplates = {
	title: "Course Templates",
	new_coursetemplate: "New Course Template",
	edit_coursetemplate: "Edit Course Template: {name}",
	view_coursetemplate: "View Course Template: {name}",
	list_title: "List of Course Templates",
	list_subtitle: "Manage Course Templates",
	create_title: "Create New Course Template",
	update_title: "Update Course Template",
	address_title: "Address",
	details_title: "Course Template Details",
	id: "ID",
	name: "Name",
	certificate_display_name: "Certificate display name",
	short_description: "Short Description",
	long_description: "Long Description",
	coursetemplatetype_id: "Type",
	pdf_template: "PDF Template",
	pdf_title: "PDF Title",
	pdf_description: "PDF Description",
	pdf_description_hint: " ",
	pdf_content: "PDF Content",
	info_link: "Info Link",
	type: "Type",
	price: "Price",
	price_proof: "Price Certificate",
	price_vat: "VAT",
	valid_for: "Valid for",
	status: "Status",
	created_by: "Created By",
	coursetypegroup_id: "Course Type Group",
	duplicate_message: "Do you want to create a copy of the template?",
	upload_pdf_template: "Upload template",
	select_pdf_template: "Select PDF",
	preview_pdf_template: "PDF Preview",
	months: "months",
	valid_for_helptext: "Leave blank for no expiration date, otherwise expiration date will be calculated from the issue date.",
	enrolment_preview: "Enrolment Preview",
	select_template_type: "Please select type of the course template (Cannot be changed!)",
	type_normal_helptext: " ",
	type_long_helptext: " ",
};
export default coursetemplates;